export type ScanClassification =
    | "threat"
    | "no_threat"
    | "undetermined";

export interface IScanSettings {
  no_result: ScanClassification;
  on_error: ScanClassification;
  vt_on: boolean;
  vt_key: string;
}

export interface ScanSettingsProps {}

export const defaultScanSettings: IScanSettings = {
  no_result: "no_threat",
  on_error: "undetermined",
  vt_on: false,
  vt_key: "",
};

export const ScanCategory: { label: string; value: ScanClassification }[] = [
  { label: "Threat", value: "threat" },
  { label: "No Threat", value: "no_threat" },
  { label: "Undetermined", value: "undetermined" },
];

export const MASKED_KEY_SYMBOL = "**********";
